import { DISABLED_PROVIDER_WEBSOCKET_CONFIG, TICK2TRADE_PROVIDER, type BackendConfig, type ProviderCapabilities } from '../adapters/types'
import { Tick2TradeAdapter } from '../adapters/Tick2TradeAdapter'
import { registerProvider } from './registry'

/** tick2trade's own backend: the full platform. */
export const TICK2TRADE_CAPABILITIES: ProviderCapabilities = {
	tradingAccountDirectory: true,
	accountMargins: true,
	brokerSessionToken: false,
	holdingsPerAccount: true,
	practiceTrade: true,
	accountProfile: true,
	reports: true,
	aiAssistant: true,
	refreshesAccessToken: true,
}

/** http(s) / ws(s) roots of the tick2trade API server from the build env. */
export const tick2tradeServerUrls = (env: ImportMetaEnv) => {
	const useSsl = env.VITE_USE_SSL === 'true'
	const server = env.VITE_API_BASE_SERVER
	return {
		apiBaseUrl: (useSsl ? 'https://' : 'http://') + server,
		wsUrl: (useSsl ? 'wss://' : 'ws://') + server + '/app',
	}
}

export const createTick2TradeConfig = (env: ImportMetaEnv): BackendConfig => {
	const { apiBaseUrl, wsUrl } = tick2tradeServerUrls(env)
	return {
		provider: TICK2TRADE_PROVIDER,
		capabilities: TICK2TRADE_CAPABILITIES,
		baseUrl: apiBaseUrl,
		wsUrl,
		providerUrl: apiBaseUrl,
		// The backend websocket already streams everything; no extra provider websocket.
		providerWebSocket: DISABLED_PROVIDER_WEBSOCKET_CONFIG,
	}
}

registerProvider({
	id: TICK2TRADE_PROVIDER,
	capabilities: TICK2TRADE_CAPABILITIES,
	createConfig: createTick2TradeConfig,
	createAdapter: (config) => new Tick2TradeAdapter(config),
})
